export default "__VITE_ASSET__bCQjLJU3__"